<div class="dialog-container">
  <h2 mat-dialog-title>
    {{ several ? ('ADD_OWNERS' | translate) : ('ADD_OWNER' | translate) }}
  </h2>
  <div mat-dialog-content class="dialog-content">
    @if (!several) {
      <div class="margin-bottom">
        {{ 'ENTER_EMAIL_TO_ADD_OWNER' | translate }}
        <br />
        {{ 'USER_TO_CONFIRM_OWNERSHIP' | translate }}
      </div>
    }
    <form>
      @if (!several) {
        <div>
          <mat-form-field class="w-full">
            <mat-label>{{ 'EMAIL' | translate }}</mat-label>
            <input matInput required name="email" [formControl]="emailCtrl" />
            @if (!emailCtrl.value) {
              <mat-error>
                {{ 'EMAIL_IS_REQUIRED' | translate }}
              </mat-error>
            }
            @if (emailCtrl.value && emailCtrl.hasError('email')) {
              <mat-error>
                {{ 'ENTER_VALID_EMAIL' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
      <div class="margin-bottom">
        <mat-checkbox [formControl]="authenticationCtrl">
          {{ 'AUTHENTICATION' | translate }}
        </mat-checkbox>
      </div>
      <div class="margin-bottom">
        <mat-checkbox [formControl]="subscriptionCtrl">
          {{ 'SUBSCIPTION_PAID_BY_END_USER' | translate }}
        </mat-checkbox>
      </div>
      <div class="margin-bottom" *canSee="[userType.Operator, userType.Support]">
        <mat-checkbox [formControl]="semiRegisterCtrl">
          {{ 'SEMI_REGISTER_USER' | translate }}
        </mat-checkbox>
      </div>
    </form>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button [disabled]="loading" color="primary" (click)="addOwner()">
      @if (!loading) {
        <span>{{ 'ADD_OWNER' | translate }}</span>
      }
      @if (loading) {
        <mat-spinner class="button-spinner"></mat-spinner>
      }
    </button>
    <button mat-raised-button (click)="dialogRef.close()">
      {{ 'CANCEL' | translate }}
    </button>
  </div>
</div>
